module.exports = __webpack_public_path__ + "static/media/box.fc6563c3.svg";